<template>
  <div class="custom-message-container" v-if="content.root == '1'">
    <div class="message-box">
      <div class="message">
        <div class="message-genre">
          <!-- <span class="origin-message-icon message-icon"></span> -->
          <img class="origin-message-icon message-icon" src="@/assets/img/im-icon/pickup.svg" alt="">
          <span class="dividing-line" v-for="item in 6" :key="item"></span>
          <span class="message-stops" v-if="content.data.stops"
            >{{ content.data.stops }} Stops</span
          >
        </div>
        <div class="message-content origin-content">
          <p class="message-title overflow-management">{{ originWaypoint }}</p>
        </div>
      </div>
      <div class="message end-message">
        <div class="message-genre">
          <!-- <span class="destination-message-icon message-icon"></span> -->
          <img class="destination-message-icon message-icon" src="@/assets/img/im-icon/pickdown.svg" alt="">
        </div>
        <div class="message-content">
          <p class="message-title overflow-management">
            {{ remainingWaypoint }}
          </p>
        </div>
      </div>
    </div>
    <div class="bottom-message">
      <p>
          <span
            >{{ distance | convertMetersToMiles(1) | toThousandFilter }}mi</span
          >
          (<span>{{ timeHourse + "h " }}</span
          ><span>{{ timeMinute + "min" }}</span
          >)
        </p>
        <p @click="clickViewDetail(content.data.webId)">View Detail</p>
    </div>
    <save-confirm
      :visible="showIsSaveConfirm"
      :loading="saveConfirmLoading"
      title="Confirmation"
      content="Would you like to  check the route detail?"
      @close="isSavehandleClose"
      @save="handleSave"
    ></save-confirm>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import SaveConfirm from "@/im/components/dialog/save-confirm";
import { convertMetersToMiles, toThousandFilter } from "@/filters";
export default {
  components: { SaveConfirm },
  data() {
    return {
      showIsSaveConfirm: false,
      saveConfirmLoading: false,
      addId: "",
    };
  },
  props: {
    content: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState({}),
    originWaypoint() {
      return (
        this.content.data &&
        this.content.data.sendData &&
        this.content.data.sendData.waypointList &&
        this.content.data.sendData.waypointList[0].title
      );
    },
    timeHourse() {
      return (
        this.content.data &&
        this.content.data.sendData &&
        this.content.data.sendData.drivingTimeHours
      );
    },
    timeMinute() {
      return (
        this.content.data &&
        this.content.data.sendData &&
        this.content.data.sendData.drivingTimeMinutes
      );
    },
    distance() {
      return (
        this.content.data &&
        this.content.data.sendData &&
        this.content.data.sendData.distance
      );
    },
    remainingWaypoint() {
      return (
        this.content.data &&
        this.content.data.sendData &&
        this.content.data.sendData.waypointList &&
        this.content.data.sendData.waypointList[1].title
      );
    },
  },
  mounted() {},
  methods: {
    convertMetersToMiles,
    toThousandFilter,
    ...mapActions({
      getSaveTripPlanInfoAsync: "tripPlan/getSaveTripPlanInfo",
      updateReproduceRouteAsync: "tripPlan/updateReproduceRoute",
    }),
    clickViewDetail(id) {
      //   this.$emit("viewDetail");
      this.addId = id;
      this.showIsSaveConfirm = true;
    },
    isSavehandleClose() {
      this.showIsSaveConfirm = false;
    },
    handleSave() {
      if (!this.$route.path.includes('map')) {
        this.$router.push('/map/index');
      }
      this.saveConfirmLoading = true;
      this.getSaveTripPlanInfoAsync({ id: this.addId })
        .then(() => {
          this.$message.success("success check the route detail");
        })
        .catch((error) => {
          if (error && error.message && error.message === "cancel request")
            return null;
          this.$message.error("Fail to load saved route info");
          this.saveConfirmLoading = false;
        })
        .finally(() => {
          this.saveConfirmLoading = false;
          this.showIsSaveConfirm = false;
          this.updateReproduceRouteAsync(false);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-message-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  &:hover {
    .delete-route {
      display: inline-block;
    }
  }
  .message-box {
    flex: 1;
    overflow: hidden;
    width: 100%;
    .end-message {
      margin-top: 20px;
    }
    .message {
      display: flex;
      align-items: stretch;
      .message-genre {
        flex-shrink: 0;
        position: relative;
        margin-right: 10px;
        text-align: center;
        .message-icon {
          display: inline-block;
          vertical-align: top;
          width: 24px;
          height: 24px;
          // width: 12px;
          // height: 12px;
        }
        .dividing-line {
          position: absolute;
          top: 25px;
          width: 3px;
          height: 3px;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          opacity: 0.2;
          background-color: #001b42;
          border-radius: 100%;
          //   background: url('~@/assets/img/share-icon/ic-point.svg') repeat-y;
        }
        .dividing-line:nth-child(3) {
          margin-top: 5px;
        }
        .dividing-line:nth-child(4) {
          margin-top: 10px;
        }
        .dividing-line:nth-child(5) {
          margin-top: 15px;
        }
        .dividing-line:nth-child(6) {
          margin-top: 20px;
        }
        .dividing-line:nth-child(7) {
          margin-top: 25px;
        }
        .message-stops {
          font-weight: 500;
          font-size: 12px;
          color: #7f8596;
          position: absolute;
          top: 26px;
          display: inline-block;
          width: 100px;
          text-align: left;
          padding-left: 10px;
        }
      }
      .message-content {
        flex: 1;
        overflow: hidden;
        display: flex;
        align-items: center;

        .message-title {
          font-weight: 500;
          font-size: 12px;
          line-height: normal;
          color: #000000;
          font-weight: 500;
        }
        .stop-number {
          margin-top: 7px;
          font-weight: 500;
          font-size: 12px;
          line-height: normal;
          color: #7f8596;
        }
      }
    }
  }
  .bottom-message {
    height: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;

    p {
      font-weight: 500;
        font-weight: 500;
        font-size: 12px;
        &:first-child {
          color: #7f8596;
        }
        &:last-child {
          color: #4066d4;
          cursor: pointer;
        }

        span {
          font-weight: 500;
          font-weight: 500;
        }
      }
  }
  .delete-route {
    display: none;
    margin-bottom: 16px;
    flex-shrink: 0;
    margin-left: 10px;
    cursor: pointer;
    font-size: 16px;
    color: #7f8da0;
    &:hover {
      color: #e14200;
    }
  }
}
</style>
